<template>
	<el-dialog
		:visible.sync="visible"
		:show-close="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		class="role-dialog"
		width="730px">
		<span slot="title" class="dialog-title">
			<span>{{title}}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false">
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="延保编号" prop="warrantyCode">
						<el-input v-model="dataForm.warrantyCode" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="购买编号" prop="purchaseCode">
						<el-input v-model="dataForm.purchaseCode" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="对应区域RTM" prop="regionRtm">
						<el-input v-model="dataForm.regionRtm" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="省份" prop="province">
						<el-input v-model="dataForm.province" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="购买经销商名" prop="buyerDealer">
						<el-input v-model="dataForm.buyerDealer" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="服务经销商名" prop="serviceDealer">
						<el-input v-model="dataForm.serviceDealer" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="客户名称" prop="customerName">
						<el-input v-model="dataForm.customerName" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="索赔增扩零件" prop="warrantyExpanded">
						<el-input v-model="dataForm.warrantyExpanded" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="机型" prop="model">
						<el-input v-model="dataForm.model" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="机号" prop="machineId">
						<el-input v-model="dataForm.machineId" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="8">
					<el-form-item label="保修起始日期" prop="warrantyStartDate">
						<el-date-picker v-model="dataForm.warrantyStartDate" type="date" value-format="yyyy-MM-dd"
										:disabled="readonly" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="首保截至日期" prop="firstServiceEndDate">
						<el-date-picker v-model="dataForm.firstServiceEndDate" type="date" value-format="yyyy-MM-dd"
										:disabled="readonly" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="延保截至日期" prop="warrantyEndDate">
						<el-date-picker v-model="dataForm.warrantyEndDate" type="date" value-format="yyyy-MM-dd"
										:disabled="readonly" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="延保年限" prop="warrantyYears">
						<el-input v-model="dataForm.warrantyYears" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="延保到期张数" prop="warrantyExpiryCount">
						<el-input v-model.number="dataForm.warrantyExpiryCount" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="12">
					<el-form-item label="延保客户类型" prop="warrantyCustomerType">
						<el-input v-model="dataForm.warrantyCustomerType" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="延保销售方式" prop="warrantySalesMethod">
						<el-input v-model="dataForm.warrantySalesMethod" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button v-if="!readonly" :loading="submitLoading" class="submit-btn" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from '@/utils/debounce'

export default {
	data() {
		return {
			title: '新增常用零件',
			visible: false,
			readonly: false,
			editType: 'add',
			submitLoading: false,
			dataForm: {
				id: '',                              // ID
				warrantyCode: '',                   // 延保编号
				purchaseCode: '',                   // 购买编号
				regionRtm: '',                      // 对应区域RTM
				province: '',                       // 省份
				buyerDealer: '',                   // 购买经销商名
				serviceDealer: '',                 // 服务经销商名
				customerName: '',                  // 客户名称
				model: '',                         // 机型
				machineId: '',                     // 机号
				warrantyStartDate: '',             // 保修起始日期
				firstServiceEndDate: '',           // 首保截至日期
				warrantyEndDate: '',               // 延保截至日期
				warrantyYears: '',                 // 延保年限
				warrantyExpiryCount: '',           // 延保到期张数
				warrantyCustomerType: '',          // 延保客户类型
				warrantySalesMethod: '',           // 延保销售方式
				warrantyExpanded: '',				// 索赔增扩零件
			},
			submitUrl: 'partsWarrantyInfoAdd',
			dataRule: {
				id: [
					{ required: true, message: 'ID不能为空', trigger: "blur" }
				],
				warrantyCode: [
					{ required: true, message: '延保编号不能为空', trigger: "blur" }
				],
				purchaseCode: [
					{ required: true, message: '购买编号不能为空', trigger: "blur" }
				],
				regionRtm: [
					{ required: true, message: '对应区域RTM不能为空', trigger: "blur" }
				],
				province: [
					{ required: true, message: '省份不能为空', trigger: "blur" }
				],
				buyerDealer: [
					{ required: true, message: '购买经销商名不能为空', trigger: "blur" }
				],
				serviceDealer: [
					{ required: true, message: '服务经销商名不能为空', trigger: "blur" }
				],
				customerName: [
					{ required: true, message: '客户名称不能为空', trigger: "blur" }
				],
				model: [
					{ required: true, message: '机型不能为空', trigger: "blur" }
				],
				machineId: [
					{ required: true, message: '机号不能为空', trigger: "blur" }
				],
				warrantyStartDate: [
					{ required: true, message: '保修起始日期不能为空', trigger: "blur" }
				],
				firstServiceEndDate: [
					{ required: true, message: '首保截至日期不能为空', trigger: "blur" }
				],
				warrantyEndDate: [
					{ required: true, message: '延保截至日期不能为空', trigger: "blur" }
				],
				warrantyYears: [
					{ required: true, message: '延保年限不能为空', trigger: "blur" }
				],
				warrantyExpiryCount: [
					{ required: true, message: '延保到期张数不能为空', trigger: "blur" }
				],
				warrantyCustomerType: [
					{ required: true, message: '延保客户类型不能为空', trigger: "blur" }
				],
				warrantySalesMethod: [
					{ required: true, message: '延保销售方式不能为空', trigger: "blur" }
				],
			}

		}
	},
	created() {
	},
	methods: {
		init(type, data) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.editType = type;
				this.dataForm ={
					...data
				}
				if (type === 'add') {
					this.title = '新增延保信息';
					this.submitUrl = 'partsWarrantyInfoAdd';
					this.readonly = false;
					delete this.dataForm.id;
				} else if (type === 'edit') {
					this.title = '修改延保信息';
					this.submitUrl = 'partsWarrantyInfoUpdate';
					this.readonly = false;
				} else {
					this.title = '查看延保信息';
					this.submitUrl = '';
					this.readonly = true;
				}
			})
		},
		submit: debounce(function () {
			if (this.visible == false) {
				return
			}
			this.$refs['dataForm'].validate(valid => {
				if (valid) {
					let that = this;
					that.submitLoading = true
					that.$request.post(
						that.submitUrl,
						false,
						that.dataForm,
						function (r) {
							if (r.code == "0") {
								that.visible = false;
								that.$emit('refresh');
								that.$message.success('保存成功');
							} else {
								that.$message.error(r.msg);
							}
							that.submitLoading = false
						}
					);
				} else {
					return false;
				}
			});
		}, 1000),
	}
}
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 10px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	width: 100%;
	background-color: #117FFC;
	color: #fff;
}

.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 30px !important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
	width: 100%;
}
</style>
